import { render, staticRenderFns } from "./VertragRuhesetzungModal.vue?vue&type=template&id=c272fd00&"
import script from "./VertragRuhesetzungModal.vue?vue&type=script&lang=js&"
export * from "./VertragRuhesetzungModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports